export enum WebSocketEvent {
  MESSAGE_CREATED = "comment.created",
  BUG_UPDATED = "bug.updated",
  BUG_CREATED = "bug.created",
  BUG_TYPING = "bug.typing",
  BOT_STARTFEEDBACKFLOW = "bot.startfeedbackflow",
  BOT_OPENLINK = "bot.openlink",
  BOT_UPDATECURRENTACTION = "bot.updatedcurrentaction",
}

export enum WebSocketDataContentType {
  MESSAGE = "MESSAGE",
  TICKET = "TICKET",
  TYPING = "TYPING",
  BOT = "BOT",
}

export type WebSocketEventData = {
  contentType: WebSocketDataContentType;
  action: WebSocketEvent;
  actionID: string;
  parentID: string;
  actionData?: any;
};

export type PreparedWebSocketEventData = {
  contentType: WebSocketDataContentType;
  action: WebSocketEvent;
  actionID: string;
  parentID: string;
};
